module.exports = __webpack_public_path__ + "static/img/GB-SCT.c305c344.svg";